import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * El acumulado del mes, dentro del grupo `_contabilidad`.
 *
 * SEPARADA DEL FORMULARIO A PROPOSITO. `rep.cortesias_mes` exige `jefe_operarios`, `contador` o
 * `administrador`, asi que el operario que registra la cortesia recibe un `42501` si consulta el
 * acumulado, y el escenario de la feature 14 dice «el administrador consulta el mes». El conjunto
 * del escenario, {administrador}, esta contenido en el de `utilidad.ver`, {contador,
 * administrador}, que es lo que este grupo exige. Adjudicacion 177.
 */
export const rutaCortesiasDelMes = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/cortesias/mes',
  component: lazyRouteComponent(() => import('./cortesias-mes-pantalla.js'), 'RutaCortesiasDelMes'),
});
